// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/lowpoly.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background-color: #aaa;
}
::-webkit-scrollbar-thumb {
  background-color: #335ddc;
  border-radius: 8px;
}
body {
  font-family: 'Poppins', sans-serif;
}
.content {
  flex: 1 1;
  padding: 32px 0;
}
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 600px;
  background: #000;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}
.login-box {
  width: 60vw;
  min-height: 400px;
  height: 70vh;
  background-color: white;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.16);
  overflow: hidden;
  margin: 0 auto;
  border-radius: 12px;
}
#login-form {
  border-radius: 0 12px 12px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #fff !important;
  padding: 0px 60px 60px 60px;
}
.illustration-wrapper-log {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: #ffffff;
  background: linear-gradient(180deg, #ffffff 0%, #f0cdf9 73%, #de90f1 88%, #ce5beb 95%);
  border-radius: 12px 0 0 12px;
}
.login-image {
  max-width: 80%;
  height: auto;
  padding: 5%;
}
#login-form p {
  margin-bottom: 20;
}
#login-form p.form-title {
  color: #5752DA;
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-size: 32px;
  font-weight: 800;
  text-align: center;
  text-decoration-line: underline;
  line-height: 24px;
  margin: 20px 20px;
}
#login-form .ant-form-item-label > label.ant-form-item-required::before {
  display: none;
}
.ant-form-item-control-input-content {
  text-align: left;
}
#login-form .ant-input-affix-wrapper {
  padding: 0px 15px;
  height: 32px;
}
#login-form_username {
  height: 32px;
}
.login-form-forgot {
  text-decoration-line: underline;
  line-height: 1;
  float: right;
}
#login-form .ant-btn {
  height: 42px;
  letter-spacing: 1px;
  border-radius: 6px;
  margin-bottom: 20;
}
.login-form-button {
  margin-top: 10px;
  width: 100%;
  background: linear-gradient(90deg, #CE5BEB 0%, #1E88E5 100%) !important;
}
#login-form p.form-not-reg {
  font-size: 14px;
  text-align: center;
}
@media screen and (max-width: 575px) {
  .login-page {
    width: 100vw;
    flex-direction: column;
    box-shadow: none;
  }
  .illustration-wrapper-log {
    display: none;
  }
  #login-form {
    padding: 20px;
    width: 100%;
  }
  .login-image {
    display: none;
    margin-left: auto;
    margin-right: auto;
  }
  .login-box {
    width: 70vw !important;
  }
}
@media screen and (max-width: 991px) {
  .login-page {
    width: 100vw;
    flex-direction: column;
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/login/index.less"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;AAEA;EACE,sBAAA;AAAF;AAGA;EACE,yBAAA;EACA,kBAAA;AADF;AAIA;EACE,kCAAA;AAFF;AAKA;EACE,SAAA;EACA,eAAA;AAHF;AAMA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,yDAAA;EACA,sBAAA;AAJF;AAOA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,wCAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AALF;AAQA;EACE,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,2BAAA;AANF;AASA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,sFAAA;EACA,4BAAA;AAPF;AAUA;EACE,cAAA;EAGA,YAAA;EACA,WAAA;AAVF;AAcA;EACE,iBAAA;AAZF;AAeA;EACE,cAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,iBAAA;EACA,iBAAA;AAbF;AAiBA;EACE,aAAA;AAfF;AAkBA;EACE,gBAAA;AAhBF;AAmBA;EACE,iBAAA;EACA,YAAA;AAjBF;AAoBA;EACE,YAAA;AAlBF;AAqBA;EACE,+BAAA;EACA,cAAA;EACA,YAAA;AAnBF;AAsBA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AApBF;AAuBA;EACE,gBAAA;EACA,WAAA;EACA,uEAAA;AArBF;AAwBA;EACE,eAAA;EACA,kBAAA;AAtBF;AAyBA;EACE;IACE,YAAA;IACA,sBAAA;IACA,gBAAA;EAvBF;EA0BA;IACE,aAAA;EAxBF;EA2BA;IACE,aAAA;IACA,WAAA;EAzBF;EA4BA;IACE,aAAA;IACA,iBAAA;IACA,kBAAA;EA1BF;EA6BA;IACE,sBAAA;EA3BF;AACF;AA8BA;EACE;IACI,YAAA;IACA,sBAAA;IACA,gBAAA;EA5BJ;AACF","sourcesContent":["::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background-color: #aaa;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #335ddc;\n  border-radius: 8px;\n}\n\nbody {\n  font-family: 'Poppins', sans-serif;\n}\n\n.content {\n  flex: 1;\n  padding: 32px 0;\n}\n\n.login-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  min-height: 600px;\n  background: #000;\n  background-image: url(\"../../assets/images/lowpoly.png\");\n  background-size: cover;\n}\n\n.login-box {\n  width: 60vw;\n  min-height: 400px;;\n  height: 70vh;\n  background-color: white;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.16);\n  overflow: hidden;\n  margin: 0 auto;\n  border-radius: 12px;\n}\n\n#login-form {\n  border-radius: 0 12px 12px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: #fff !important;\n  padding: 0px 60px 60px 60px;\n}\n\n.illustration-wrapper-log {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  background: rgb(255, 255, 255);\n  background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(240, 205, 249, 1) 73%, rgba(222, 144, 241, 1) 88%, rgba(206, 91, 235, 1) 95%);\n  border-radius: 12px 0 0 12px;\n}\n\n.login-image {\n  max-width: 80%;\n  // max-height: 80%;\n  // width: auto;\n  height: auto;\n  padding: 5%;\n  // aspect-ratio: 1/1;\n}\n\n#login-form p {\n  margin-bottom: 20;\n}\n\n#login-form p.form-title {\n  color: #5752DA;\n  font-family: 'Poppins', sans-serif;\n  font-style: normal;\n  font-size: 32px;\n  font-weight: 800;\n  text-align: center;\n  text-decoration-line: underline;\n  line-height: 24px;\n  margin: 20px 20px;\n}\n\n\n#login-form .ant-form-item-label>label.ant-form-item-required::before {\n  display: none;\n}\n\n.ant-form-item-control-input-content {\n  text-align: left;\n}\n\n#login-form .ant-input-affix-wrapper {\n  padding: 0px 15px;\n  height: 32px;\n}\n\n#login-form_username {\n  height: 32px;\n}\n\n.login-form-forgot {\n  text-decoration-line: underline;\n  line-height: 1;\n  float: right;\n}\n\n#login-form .ant-btn {\n  height: 42px;\n  letter-spacing: 1px;\n  border-radius: 6px;\n  margin-bottom: 20;\n}\n\n.login-form-button {\n  margin-top: 10px;\n  width: 100%;\n  background: linear-gradient(90deg, #CE5BEB 0%, #1E88E5 100%) !important;\n}\n\n#login-form p.form-not-reg {\n  font-size: 14px;\n  text-align: center;\n}\n\n@media screen and (max-width: 575px) {\n  .login-page {\n    width: 100vw;\n    flex-direction: column;\n    box-shadow: none;\n  }\n\n  .illustration-wrapper-log {\n    display: none;\n  }\n\n  #login-form {\n    padding: 20px;\n    width: 100%;\n  }\n\n  .login-image {\n    display: none;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .login-box{\n    width: 70vw !important;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .login-page {\n      width: 100vw;\n      flex-direction: column;\n      box-shadow: none;\n    }\n}\n\n@media screen and (min-width: 1200px) {\n  // .login-box {\n  //   height: 70vh;\n  // }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
